import { redirect } from "@tanstack/react-router";

/**
 * Route `onError` handler that sends the user home when the URL is missing the
 * search params the route requires, and rethrows everything else.
 *
 * Note the signature: TanStack Router calls `onError` with the error itself as
 * a single positional argument, not with an options object. Destructuring an
 * `{ error }` property here yields `undefined` and turns every route error into
 * a TypeError, which is silently swallowed into the route's error state -- the
 * user gets an error screen instead of the redirect.
 */
export function redirectHomeOnInvalidSearch(error: unknown): never {
  if (
    typeof error === "object" &&
    error !== null &&
    (error as { routerCode?: unknown }).routerCode === "VALIDATE_SEARCH"
  ) {
    throw redirect({ to: "/" });
  }
  throw error;
}
